/* Megamenu
$('.has-children').click(function () {
  $(this).children('.megamenu-dropdown').toggleClass('open');
});
*/
